var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBellOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M16.166 15.736h-11.5V8.07a5.756 5.756 0 0 1 5.75-5.75 5.756 5.756 0 0 1 5.75 5.75zm-5.75 3.834A1.919 1.919 0 0 1 8.5 17.653h3.834c0 1.057-.86 1.917-1.917 1.917zm8.625-3.834h-.958V8.07c0-4.227-3.44-7.667-7.667-7.667S2.75 3.842 2.75 8.07v7.667h-.958a.957.957 0 1 0 0 1.917h4.792a3.837 3.837 0 0 0 3.833 3.833 3.837 3.837 0 0 0 3.834-3.833h4.791a.957.957 0 1 0 0-1.917z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBellOutline);
export default __webpack_public_path__ + "static/media/icon-bell-outline.304f62b57ecf0b3d7bd47c0c36299cea.svg";
export { ForwardRef as ReactComponent };